import VueRouter from "vue-router";
import {getBackofficeRole, isAdmin, isAuthenticated, logout} from "@/util/authenticator.js";
import LoginPage from "@/components/pages/Login.vue";
import HomePage from "@/components/pages/Home.vue";
import Users from "@/components/pages/Users.vue";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";

const routes = [
    {
        path: "/bad-words",
        name: "",
        component: DefaultLayout,
        children: [{
          path: "",
          name: "Bad Words",
          meta: {"userRoles":["super-admin"]},
          component: () => import(/* webpackChunkName: "bad-words-page" */ "../components/pages/BadWords.vue")
        }]
    },
    { path: "/users", component: Users },
    {
        path: "/organisations",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Organisations",
            meta: {"userRoles":["super-admin"]},
            component: () => import(/* webpackChunkName: "organisations-page" */ "../components/pages/Organisations.vue")
        }]
    },
    {
        path: "/organisations/add",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Add Organisation",
            meta: {"userRoles":["super-admin"]},
            component: () => import(/* webpackChunkName: "add-organisation-page" */ "../components/pages/OrganisationEditor.vue")
        }]
    },
    {
        path: "/organisations/:id",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Edit Organisation",
            meta: {"userRoles":["super-admin", "admin"]},
            component: () => import(/* webpackChunkName: "edit-organisation-page" */ "../components/pages/OrganisationEditor.vue")
        }]
    },
    {
        path: "/organisations/:id/admins",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Admins",
            meta: {"userRoles":["super-admin"]},
            component: () => import(/* webpackChunkName: "admins-page" */ "../components/pages/Admins.vue")
        }]
    },
    {
        path: "/organisations/:id/admins/add",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Add Admin",
            meta: {"userRoles":["super-admin"]},
            component: () => import(/* webpackChunkName: "add-admin-page" */ "../components/pages/AddAdmin.vue")
        }]
    },
    {
        path: "/locations",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Locations",
            meta: {"userRoles":["admin"]},
            component: () => import(/* webpackChunkName: "locations-page" */ "../components/pages/Locations.vue")
        }]
    },
    {
        path: "/locations/add",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Add Location",
            meta: {"userRoles":["admin"]},
            component: () => import(/* webpackChunkName: "add-location-page" */ "../components/pages/LocationEditor.vue")
        }]
    },
    {
        path: "/locations/:id",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Edit Location",
            meta: {"userRoles":["admin","manager"]},
            component: () => import(/* webpackChunkName: "edit-location-page" */ "../components/pages/LocationEditor.vue")
        }]
    },
    {
        path: "/locations/:id/manager",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "manager",
            meta: {"userRoles":["admin"]},
            component: () => import(/* webpackChunkName: "manager-page" */ "../components/pages/Manager.vue")
        }]
    },
    {
        path: "/locations/:id/manager/add",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Add Manager",
            meta: {"userRoles":["admin"]},
            component: () => import(/* webpackChunkName: "add-manager-page" */ "../components/pages/AddManager.vue")
        }]
    },
    {
        path: "/communities",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Communities",
            meta: {"userRoles":["manager","community-manager", "super-admin"]},
            component: () => import(/* webpackChunkName: "communities-page" */ "../components/pages/Communities.vue")
        }]
    },
    {
        path: "/communities/add",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Add Community",
            meta: {"userRoles":["manager","community-manager", "super-admin"]},
            component: () => import(/* webpackChunkName: "add-community-page" */ "../components/pages/CommunityEditor.vue")
        }]
    },
    {
        path: "/communities/:id",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Edit Community",
            meta: {"userRoles":["manager","community-manager", "super-admin"]},
            component: () => import(/* webpackChunkName: "edit-community-page" */ "../components/pages/CommunityEditor.vue")
        }]
    },
    {
        path: "/communities/:id/community-manager",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Community Manager",
            meta: {"userRoles":["manager", "super-admin"]},
            component: () => import(/* webpackChunkName: "community-manager-page" */ "../components/pages/CommunityManager.vue")
        }]
    },
    {
        path: "/communities/:id/community-manager/add",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Add Community Manager",
            meta: {"userRoles":["manager", "super-admin"]},
            component: () => import(/* webpackChunkName: "add-community-manager-page" */ "../components/pages/AddCommunityManager.vue")
        }]
    },
    {
        path: "/communities/:id/moderators",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Moderators",
            meta: {"userRoles":["community-manager"]},
            component: () => import(/* webpackChunkName: "add-community-manager-page" */ "../components/pages/Moderator.vue")
        }]
    },
    {
        path: "/communities/:id/access-requests",
        name: "",
        component: DefaultLayout,
        children: [{
            path: "",
            name: "Access Requests",
            meta: {"userRoles":["super-admin", "manager", "community-manager"]},
            component: () => import(/* webpackChunkName: "access-request-page" */ "../components/pages/AccessRequests.vue")
        }]
    },
    { path: "/login", component: LoginPage },
    { path: "/", component: HomePage }
];

export const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path !== "/login" && !isAuthenticated()) {
        next({ path: "/login" });
    } else if(isAuthenticated() && !isAdmin()) {
        logout();
    } else {
        const backOfficeRole = getBackofficeRole();
        console.log("to.meta.userRoles", to.meta.userRoles && to.meta.userRoles.includes(backOfficeRole));
        if(to.path === "/") {
            switch (backOfficeRole) {
                case "super-admin":
                    next("/organisations");
                    break;
                case "admin":
                    next("/locations");
                    break;
                case "manager":
                    next("/communities");
                    break;
                case "community-manager":
                    next("/communities");
                    break;
            }
        }
        else if(to.path !== "/" && to.meta.userRoles && !to.meta.userRoles.includes(backOfficeRole)) next(false);
        else next();
    }
});
